import React from 'react';
import styled from 'styled-components';

const RemoveGrey = () => {
return(
    <Container>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 37.5C10.335 37.5 2.5 29.665 2.5 20C2.5 10.335 10.335 2.5 20 2.5C29.665 2.5 37.5 10.335 37.5 20C37.5 29.665 29.665 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
            fill="#333333" fill-opacity="0.3"/>
        <path
            d="M11.6161 11.6161C12.1043 11.128 12.8957 11.128 13.3839 11.6161L20 18.2322L26.6161 11.6161C27.1043 11.128 27.8957 11.128 28.3839 11.6161C28.872 12.1043 28.872 12.8957 28.3839 13.3839L21.7678 20L28.3839 26.6161C28.872 27.1043 28.872 27.8957 28.3839 28.3839C27.8957 28.872 27.1043 28.872 26.6161 28.3839L20 21.7678L13.3839 28.3839C12.8957 28.872 12.1043 28.872 11.6161 28.3839C11.128 27.8957 11.128 27.1043 11.6161 26.6161L18.2322 20L11.6161 13.3839C11.128 12.8957 11.128 12.1043 11.6161 11.6161Z"
            fill="#333333" fill-opacity="0.3"/>
      </svg>
    </Container>
)

}
export default RemoveGrey;

const Container = styled.div`
    cursor: pointer;
`;